import React from 'react';

/**
 * Shared label for form fields when you need a standalone label (e.g. for custom widgets).
 */
export default function FormLabel({ htmlFor, children, required, className = '' }) {
  return (
    <label htmlFor={htmlFor} className={`form-label ${className}`}>
      {children}
      {required && <span className="text-danger ms-1">*</span>}
    </label>
  );
}
